import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useInterval } from "@/lib/useInterval";
import { Megaphone } from "lucide-react";

export default function BroadcastBar() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  // Broadcasts rarely change. WS pushes new-broadcast events; this poll is a safety net.
  // Visibility-aware so background tabs don't poll.
  useInterval(() => {
    api.get("/broadcasts/active").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, 15000);

  useEffect(() => {
    if (items.length <= 1) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 4500);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) {
    return null;
  }
  const cur = items[idx % items.length];
  return (
    <div className="h-8 w-full bg-amber-100 text-amber-900 text-xs font-semibold tracking-wide flex items-center justify-center fixed top-0 left-0 right-0 z-50 px-4" data-testid="broadcast-bar">
      <Megaphone className="h-3 w-3 mr-2 shrink-0" />
      <span className="truncate" data-testid="broadcast-message">{cur.message}{cur.target_client_id ? ` • for ${cur.target_client_id}` : ""}</span>
    </div>
  );
}
